export default __webpack_public_path__ + "static/media/790246046802509884.3873e947.png";